function isModificationRequest(text: string): boolean {
  return /这张|这个图|这幅|把它|它的|基于|沿用|保留|不变|改成|变成|换成|调整|修改|编辑|改一下|修一下|加上|添加|去掉|删掉|移除|换掉|背景|水印|扩图|补全|在此基础|继续改|继续/.test(text);
}

function isNewGenerationRequest(text: string): boolean {
  return /重新生成一张|重新画一张|新生成一张|生成新的|换一张新的|不要基于|不基于|不用上一张|不要参考上一张|全新/.test(text);
}

export function shouldUseLastResultAsReference({
  text,
  hasResult,
  hasUploadedImages,
  hasPriorImageMessages,
}: {
  text: string;
  hasResult: boolean;
  hasUploadedImages: boolean;
  hasPriorImageMessages: boolean;
}): boolean {
  if (!hasResult || hasUploadedImages || isNewGenerationRequest(text)) return false;
  return isModificationRequest(text) || (hasPriorImageMessages && isModificationRequest(text));
}
